/* Produktfilter (25.09.2026), geladen aus snippets/faceted-filters.liquid.
   1. Auf und Zu je Filtergruppe merken (sessionStorage), auch nach dem AJAX Neuladen der Filterleiste (Symmetry ersetzt .filters__inner komplett).
   2. Pantone Liste: Farbkacheln aus assets/vp-pantone.json (plus vp-pantone-extra.json für TCX), clientseitige Suche. Fehlt ein Code, bleibt die graue Kachel mit Fragezeichen.
   Das Variantenbild bei aktivem Farbfilter setzt snippets/product-block.liquid serverseitig (26.09.2026), nicht mehr dieses Skript.
   Keine Abhängigkeiten, alle Zugriffe auf sessionStorage in try/catch. */
(function () {
  if (window.vpFilterInit) return;
  window.vpFilterInit = true;

  var KEY = 'vp-filter-offen';
  function lesen() { try { return JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function schreiben(st) { try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }

  // ---------- 1. Auf und Zu ----------
  function zustandAnwenden(root) {
    var st = lesen();
    root.querySelectorAll('[data-vp-filter]').forEach(function (g) {
      var param = g.getAttribute('data-vp-filter'); if (!(param in st)) return;
      var kopf = g.querySelector('.filter-group__heading'); var ziel = g.querySelector('.filter-group__items'); if (!kopf || !ziel) return;
      var offen = !!st[param]; if (!offen && g.hasAttribute('data-vp-aktiv')) return; // aktive Filter bleiben offen
      ziel.classList.toggle('toggle-target--hidden', !offen);
      kopf.classList.toggle('toggle-target-toggler--is-hidden', !offen);
      kopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var kopf = e.target.closest && e.target.closest('[data-vp-filter] > .filter-group__heading'); if (!kopf) return;
    var param = kopf.parentElement.getAttribute('data-vp-filter');
    // ToggleTarget setzt die Klasse am Kopf sofort; danach den neuen Zustand merken
    setTimeout(function () { var st = lesen(); st[param] = !kopf.classList.contains('toggle-target-toggler--is-hidden'); schreiben(st); }, 0);
  });

  // ---------- 2. Pantone ----------
  var pantoneMap = null; var pantoneLaden = null;
  function pantoneKey(code) { return String(code || '').toUpperCase().replace(/^PANTONE\s+/, 'PMS ').replace(/\s+/g, ' ').trim(); }
  // assets/vp-pantone.json ([name, hex], C Codes) plus assets/vp-pantone-extra.json (TCX Codes aus dem XD Feed, scripts/filter-sync.ts --pantone-extra)
  function pantoneHolen(url, extraUrl) {
    if (pantoneMap) return Promise.resolve(pantoneMap);
    var laden = function (u) { return u ? fetch(u).then(function (r) { return r.ok ? r.json() : []; }).catch(function () { return []; }) : Promise.resolve([]); };
    if (!pantoneLaden) pantoneLaden = Promise.all([laden(url), laden(extraUrl)]).then(function (teile) {
      pantoneMap = {}; teile.forEach(function (liste) { (liste || []).forEach(function (x) { if (x && x[0] && x[1]) { var k = String(x[0]).toUpperCase().replace(/\s+/g, ' ').trim(); if (!pantoneMap[k]) pantoneMap[k] = x[1]; } }); });
      return pantoneMap;
    });
    return pantoneLaden;
  }
  function pantoneInit(root) {
    root.querySelectorAll('.vp-pantone').forEach(function (box) {
      if (box.dataset.vpInit) return; box.dataset.vpInit = '1';
      var suche = box.querySelector('.vp-pantone__suche'); var leer = box.querySelector('.vp-pantone__leer');
      var eintraege = Array.prototype.slice.call(box.querySelectorAll('[data-pantone]'));
      pantoneHolen(box.getAttribute('data-pantone-url'), box.getAttribute('data-pantone-extra-url')).then(function (map) {
        eintraege.forEach(function (el) {
          var k = pantoneKey(el.getAttribute('data-pantone'));
          // exakt, sonst derselbe Farbton gestrichen (U → C) als Näherung
          var hex = map[k] || map[k.replace(/ U$/, ' C')] || null;
          var kachel = el.querySelector('.vp-swatch--pantone'); if (!kachel || !hex) return;
          kachel.style.setProperty('--vp-swatch', hex); kachel.classList.remove('vp-swatch--unbekannt');
        });
      });
      if (!suche) return;
      ['change', 'input', 'keydown'].forEach(function (typ) {
        suche.addEventListener(typ, function (e) { e.stopPropagation(); if (typ === 'keydown' && e.key === 'Enter') e.preventDefault(); if (typ === 'keydown') return;
          var q = suche.value.toLowerCase().replace(/^pantone\s*/, '').replace(/\s+/g, ' ').trim(); var sichtbar = 0;
          eintraege.forEach(function (el) { var t = el.getAttribute('data-pantone').toLowerCase(); var an = !q || t.indexOf(q) >= 0 || el.classList.contains('filter-group__item--active'); el.hidden = !an; if (an) sichtbar++; });
          if (leer) leer.hidden = sichtbar > 0;
        });
      });
    });
  }
  // Symmetry liest beim Absenden alle Inputs der Leiste ein (ajaxLoadForm), das Suchfeld darf nicht mitgehen
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.classList || !e.target.classList.contains('filter-group__checkbox')) return;
    document.querySelectorAll('.vp-pantone__suche').forEach(function (s) { s.value = ''; });
  }, true);

  function alles(root) { zustandAnwenden(root); pantoneInit(root); }
  function start() {
    alles(document);
    // Symmetry ersetzt beim Filtern den Inhalt der data-ajax-container (Filterleiste, Raster); „Mehr laden“ hängt Karten an. Danach neu anwenden, gebündelt über einen kurzen Timer.
    var geplant = false; var leiste = false;
    new MutationObserver(function (list) {
      var neu = false;
      list.forEach(function (m) { if (!m.addedNodes || !m.addedNodes.length) return; neu = true; if (m.target && m.target.closest && m.target.closest('.filters__inner, .filters')) leiste = true; });
      if (!neu || geplant) return; geplant = true;
      setTimeout(function () { geplant = false; if (leiste) { zustandAnwenden(document); pantoneInit(document); } leiste = false; }, 30); // Timer statt requestAnimationFrame: läuft auch in Hintergrund Tabs
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
